export const disqualifyingOffensesOptions = [
  { label: 'Murder', value: 'murder'},
  { label: 'Trafficking of persons', value: 'human_trafficking'},
  { label: 'Aggravated kidnapping', value: 'aggravated_kidnapping'},
  { label: 'Injury to a child, elderly individual, or a disabled individual', value: 'injury_child_elderly_disabled'},
  { label: 'Abandoning or endangering a child', value: 'child_abandoning_endangerment'},
  { label: 'Any offense involving family violence including violations of bond or court orders', value: 'family_violence'},
  { label: 'Stalking', value: 'stalking'},
  { label: 'Any offense requiring registration as a sex offender', value: 'sex_offender'},
]